<template>
  <div>
    <h2>Create new plan</h2>
    <p>
      Which option for the guarantee question will this plan fall under?
    </p>
    <form @submit.prevent="submit">
      <label for="guarantee-type">
        <select v-model="guarantee_type" id="guarantee-type">
          <option :value="null" disabled>Select an option</option>
          <option :value="0">Yes</option>
          <option :value="1">No</option>
          <option :value="2">Not sure</option>
        </select>
      </label>

      <label for="name" class="form-input">
        <span>Plan Name</span>
        <input type="text" id="name" v-model="name">
      </label>

      <label for="monthly" class="form-input">
        <span>Monthly cost (£)</span>
        <input type="text" id="monthly" v-model="monthly">
      </label>

      <p>Features</p>
      <div class="features">
        <label for="helpline" class="form-checkbox">
          <input id="helpline" type="checkbox" value="helpline" v-model="features">
          <span>24/7 Helpline</span>
        </label>

        <label for="service" class="form-checkbox">
          <input id="service" type="checkbox" value="service" v-model="features">
          <span>Annual Service</span>
        </label>

        <label for="call_out" class="form-checkbox">
          <input id="call_out" type="checkbox" value="call_out" v-model="features">
          <span>Emergency Call Out 365 days per year</span>
        </label>

        <label for="boiler" class="form-checkbox">
          <input id="boiler" type="checkbox" value="boiler" v-model="features">
          <span>Boiler</span>
        </label>

        <label for="time_temperature" class="form-checkbox">
          <input id="time_temperature" type="checkbox" value="time_temperature" v-model="features">
          <span>Time & Temperature Controls</span>
        </label>

        <label for="pump" class="form-checkbox">
          <input id="pump" type="checkbox" value="pump" v-model="features">
          <span>Pump & Motorised Valves</span>
        </label>

        <label for="radiators" class="form-checkbox">
          <input id="radiators" type="checkbox" value="radiators" v-model="features">
          <span>Radiators & Valves</span>
        </label>

        <label for="cylinder" class="form-checkbox">
          <input id="cylinder" type="checkbox" value="cylinder" v-model="features">
          <span>Hot Water Cylinder</span>
        </label>

        <label for="pipework" class="form-checkbox">
          <input id="pipework" type="checkbox" value="pipework" v-model="features">
          <span>System Pipework</span>
        </label>

        <label for="drainage" class="form-checkbox">
          <input id="drainage" type="checkbox" value="drainage" v-model="features">
          <span>Hot/Cold Water Pipes, Gas Supply & Internal Drainage</span>
        </label>

        <label for="electrics" class="form-checkbox">
          <input id="electrics" type="checkbox" value="electrics" v-model="features">
          <span>Home Electrics</span>
        </label>

        

      </div>
      <button @click.prevent="submit" class="submit-button">Create new plan</button>
      <p class="error" v-if="error" v-html="error"></p>
    </form>
  </div>
</template>

<script>
export default {
  name: "PlanCreator",
  props: {
    base: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      name: '',
      guarantee_type: 0,
      monthly: 0,
      features: [],
      error: null,
    }
  },
  methods: {
    submit() {
      this.error = null;
      let data = {
        plan_name: this.name,
        guarantee_type: this.guarantee_type,
        monthly_cost: this.monthly,
        features: this.features,
      };
      this.$axios.post(`${this.base}/api/plans/create.php`, this.$makeForm(data))
          .then((response) => {
            if (response.data === "saved"){
              this.$emit('save');
            }
            else{
              this.error = response.data;
            }
          });
    },
  }
}
</script>

<style lang="scss" scoped>
form {
  width: 50%;
}

.form-input {
  width: 100%;
  margin: 1rem 0;
  display: block;

  span, input[type=text] {
    width: 100%;
    display: block;
  }

  span {
    margin-bottom: 0.5rem;
  }

  &.half {
    width: 40%;
    margin-right: 5%;
    display: inline-block;
  }
}

.form-checkbox {
  margin: 1rem 1rem 1rem 0;
  display: inline-flex;

  span, input {
    align-self: center;
  }

  span {
    margin-left: 0.4rem;
  }
}

.submit-button {
  display: block;
  margin: 1rem 0;
  background-color: #005EAE;
  color: #FFF;
  border-radius: 5px;
  padding: 0.5rem;
  border: none;
  outline: none;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    background-color: #004885;
    transition: 0.2s;
  }
}
.error{
  color: red;
  margin: 1rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/PlanCreator.vue